import {TransportEntity} from "@ots-frontend/ots-data";
import {EntityMarker, EntityMarkerProps} from "../../marker/EntityMarker/EntityMarker";
import {getTransportColorByType} from "../../../../util/transport-ui-util";

const getIcon = (color: string) : string => {
  return `data:image/svg+xml,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20height=%2240px%22%20viewBox=%220%20-960%20960%20960%22%20width=%2240px%22%20fill=%22${color.replace("#", "%23")}%22%3E%3Cpath%20d=%22m636-458.67%2084%2078V-314H513.33v240.67L480-40l-33.33-33.33V-314H240v-66.67l80-78V-774h-46.67v-66.67h409.34V-774H636v315.33Z%22/%3E%3C/svg%3E`
}

export type TransportMarkersProps = Omit<EntityMarkerProps<TransportEntity>, 'entity' | 'position' | 'options' | 'icon'> & {
  transports: TransportEntity[];
}

export const TransportMarkers = (props: TransportMarkersProps) => {
  const {transports, ...rest} = props


  return (
    <>
      {transports.map((transport) => {
        return (
          <EntityMarker
            {...rest}
            key={transport.id}
            entity={transport}
            position={{
              lat: transport.coordinates!.latCoord,
              lng: transport.coordinates!.longCoord,
            }}
            icon={{
              url: getIcon(getTransportColorByType(transport.type)),
            }}
          />
        )
      })}
    </>
  )
}
